<template>
  <div class="address-book-page">
    <div class="page-header">
      <h2>地址薄管理</h2>
    </div>

    <!-- 搜索栏 -->
    <div class="search-section">
      <div class="search-inputs">
        <el-input
          v-model="searchForm.contactName"
          placeholder="联系人"
          clearable
          style="width: 150px; margin-right: 10px"
        ></el-input>
        <el-input
          v-model="searchForm.mobile"
          placeholder="手机号"
          clearable
          style="width: 150px; margin-right: 10px"
        ></el-input>
        <el-input
          v-model="searchForm.companyName"
          placeholder="公司名称"
          clearable
          style="width: 150px; margin-right: 10px"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="handleAddAddress">新增地址</el-button>
    </div>

    <!-- 地址列表 -->
    <el-table
      :data="addressList"
      border
      stripe
      style="width: 100%; margin-top: 20px"
      v-loading="addressLoading"
    >
      <el-table-column prop="contactName" label="联系人" width="120"></el-table-column>
      <el-table-column prop="mobile" label="手机号" width="130"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="地址" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ formatAddress(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-edit" @click="handleEditAddress(scope.row)">编辑</el-button>
          <el-button type="text" icon="el-icon-delete" style="color: #F56C6C" @click="handleDeleteAddress(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>

    <!-- 新增/编辑地址对话框 -->
    <el-dialog
      :title="addressFormTitle"
      :visible.sync="addressFormDialog"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="addressForm" :rules="addressFormRules" ref="addressForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactName">
              <el-input v-model="addressForm.contactName" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="addressForm.mobile" placeholder="请输入手机号" type="tel"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="addressForm.companyName" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="省市区">
          <el-cascader
            v-model="selectedArea"
            :options="areaOptions"
            :props="{ expandTrigger: 'hover', checkStrictly: true }"
            placeholder="请选择省市区"
            style="width: 100%"
            clearable
            @change="handleAreaChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="addressDetail">
          <el-input 
            v-model="addressForm.addressDetail" 
            type="textarea"
            :rows="3"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addressFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddressForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import areaData from "@/assets/area-select-data.json";

export default {
  name: "AddressBook",
  data() {
    return {
      // 搜索表单
      searchForm: {
        contactName: "",
        mobile: "",
        companyName: "",
        province: "",
        city: "",
        district: "",
      },
      addressList: [],
      addressLoading: false,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      // 省市区数据
      areaOptions: areaData,
      selectedArea: [],
      // 新增/编辑地址表单
      addressFormDialog: false,
      addressFormTitle: "新增地址",
      addressForm: {
        id: null,
        contactName: "",
        mobile: "",
        companyName: "",
        province: "",
        city: "",
        district: "",
        address: "",
        addressDetail: "",
      },
      addressFormRules: {
        contactName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" },
        ],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getAddressList();
  },
  methods: {
    // 格式化地址
    formatAddress(row) {
      const parts = [
        row.province,
        row.city,
        row.district,
        row.addressDetail,
      ].filter(Boolean);
      return parts.join(" ") || "-";
    },
    // 处理省市区选择变化
    handleAreaChange(value) {
      if (value && value.length > 0) {
        const labels = this.getAreaLabels(value);
        this.addressForm.province = labels[0] || "";
        this.addressForm.city = labels[1] || "";
        this.addressForm.district = labels[2] || "";
      } else {
        this.addressForm.province = "";
        this.addressForm.city = "";
        this.addressForm.district = "";
      }
    },
    // 根据选中的value获取label
    getAreaLabels(values) {
      const labels = [];
      let currentOptions = this.areaOptions;
      
      for (let i = 0; i < values.length; i++) {
        const item = currentOptions.find(opt => opt.value === values[i]);
        if (item) {
          labels.push(item.label);
          currentOptions = item.children || [];
        }
      }
      
      return labels;
    },
    // 根据省市区名称查找对应的value数组
    getAreaValues(province, city, district) {
      const values = [];
      
      if (!province) return values;
      
      // 查找省
      const provinceItem = this.areaOptions.find(p => p.label === province);
      if (!provinceItem) return values;
      values.push(provinceItem.value);
      
      if (!city) return values;
      
      // 查找市
      if (provinceItem.children) {
        const cityItem = provinceItem.children.find(c => c.label === city);
        if (!cityItem) return values;
        values.push(cityItem.value);
        
        if (!district) return values;
        
        // 查找区
        if (cityItem.children) {
          const districtItem = cityItem.children.find(d => d.label === district);
          if (!districtItem) return values;
          values.push(districtItem.value);
        }
      }
      
      return values;
    },
    // 获取地址列表
    getAddressList() {
      this.addressLoading = true;
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchForm,
      };
      this.$http
        .post("/manage/outBillAddress/page", params)
        .then((res) => {
          if (res.data.code === 0) {
            this.addressList = res.data.data.records || [];
            this.totalCount = res.data.data.total || 0;
          } else {
            this.$message({
              message: res.data.message || "获取列表失败",
              type: "error",
            });
          }
          this.addressLoading = false;
        })
        .catch(() => {
          this.addressLoading = false;
          this.$message({
            message: "获取列表失败",
            type: "error",
          });
        });
    },
    // 搜索地址
    handleSearch() {
      this.currentPage = 1;
      this.getAddressList();
    },
    // 重置搜索
    handleReset() {
      this.searchForm = {
        contactName: "",
        mobile: "",
        companyName: "",
        province: "",
        city: "",
        district: "",
      };
      this.currentPage = 1;
      this.getAddressList();
    },
    // 分页切换
    handlePageChange(page) {
      this.currentPage = page;
      this.getAddressList();
    },
    // 每页数量切换
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getAddressList();
    },
    // 新增地址
    handleAddAddress() {
      this.addressFormTitle = "新增地址";
      this.addressForm = {
        id: null,
        contactName: "",
        mobile: "",
        companyName: "",
        province: "",
        city: "",
        district: "",
        address: "", // 保留字段但不显示在表单中
        addressDetail: "",
      };
      this.selectedArea = [];
      this.addressFormDialog = true;
      this.$nextTick(() => {
        if (this.$refs.addressForm) {
          this.$refs.addressForm.clearValidate();
        }
      });
    },
    // 编辑地址
    handleEditAddress(row) {
      this.addressFormTitle = "编辑地址";
      this.addressForm = {
        id: row.id,
        contactName: row.contactName,
        mobile: row.mobile,
        companyName: row.companyName,
        province: row.province,
        city: row.city,
        district: row.district,
        address: row.address || "", // 保留字段但不显示在表单中
        addressDetail: row.addressDetail,
      };
      // 根据省市区名称回填级联选择器的值
      this.selectedArea = this.getAreaValues(row.province, row.city, row.district);
      this.addressFormDialog = true;
      this.$nextTick(() => {
        if (this.$refs.addressForm) {
          this.$refs.addressForm.clearValidate();
        }
      });
    },
    // 删除地址
    handleDeleteAddress(row) {
      this.$confirm("确定要删除该地址吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/manage/outBillAddress/delete", { id: row.id })
            .then((res) => {
              if (res.data.code === 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getAddressList();
              } else {
                this.$message({
                  message: res.data.message || "删除失败",
                  type: "error",
                });
              }
            })
            .catch(() => {
              this.$message({
                message: "删除失败",
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    // 提交地址表单
    submitAddressForm() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          const params = { ...this.addressForm };
          // 如果没有id，删除id字段
          if (!params.id) {
            delete params.id;
          }
          this.$http
            .post("/manage/outBillAddress/save", params)
            .then((res) => {
              if (res.data.code === 0) {
                this.$message({
                  message: this.addressForm.id ? "修改成功" : "新增成功",
                  type: "success",
                });
                this.addressFormDialog = false;
                this.getAddressList();
              } else {
                this.$message({
                  message: res.data.message || "操作失败",
                  type: "error",
                });
              }
            })
            .catch(() => {
              this.$message({
                message: "操作失败",
                type: "error",
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.address-book-page {
  padding: 20px;
  background-color: #fff;
  min-height: calc(100vh - 100px);
}

.page-header {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #303133;
}

.search-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  flex-wrap: wrap;
  gap: 10px;
}

.search-inputs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}
</style>

